import { getV1CompaniesCompanyIdSettlementsEmails } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import {
  SettlementEmailDraft,
  SettlementTicketAttachmentOptions,
} from '~hooks/useSettlements/models';
import useEmailDraftsQuery from '~queries/useEmailDraftsQuery';

export default function useSettlementEmailDraftsQuery(
  companyId: string,
  settlementIds: string[],
  { attachTickets, ticketAttachmentMode }: SettlementTicketAttachmentOptions,
) {
  return useEmailDraftsQuery({
    enabled: Boolean(companyId) && settlementIds.length > 0,
    errorMessage: t('error_messages.settlements.failed_to_fetch_email_drafts'),
    fetchDrafts: async (signal) => {
      const response = await getV1CompaniesCompanyIdSettlementsEmails({
        path: { 'company-id': companyId },
        query: {
          settlement_ids: settlementIds,
          attach_tickets: attachTickets,
          ...(attachTickets ? { ticket_attachment_mode: ticketAttachmentMode } : {}),
        },
        signal,
      });

      return {
        drafts: response.data.data.emails.map((email) =>
          SettlementEmailDraft.parse(email, attachTickets),
        ),
      };
    },
    keepPreviousData: true,
    queryKey: [
      'settlementEmailDrafts',
      companyId,
      settlementIds,
      attachTickets,
      ticketAttachmentMode,
    ],
  });
}
